import EximBillingIndex from "@/components/exim/billing/bill_header/EximBillingIndex.vue";
import EximBillingDetail from "@/components/exim/billing/bill_header/EximBillingDetail.vue";

let EximBillingRoute= [
    {
        path: '',
        meta: {
          title: "Exim Billing",
        },
        name: "EximBillingIndex",
        component: EximBillingIndex
    },
    {
      path: 'detail/:id',
      meta: {
        title: "Exim Billing Detail",
      },
      name: "EximBillingDetail",
      component: EximBillingDetail
    }
    
]

export default EximBillingRoute
  